import * as CL from '@design-system/component-library';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';
import { NumberPrivacyFields, NumberPrivacyType } from './NumberPrivacyFields.js';
import type { PbxDirectoryDetails, VoiceDirectoryDetails } from '../../../common/types/subscription.js';

interface UserNumberPrivacyProps {
  pbxType?: string;
  voiceDirectoryDetails?: VoiceDirectoryDetails;
  corporateDirectoryDetails?: PbxDirectoryDetails;
  disabled?: boolean;
}

export const UserNumberPrivacy = ({
  pbxType,
  corporateDirectoryDetails,
  voiceDirectoryDetails,
  disabled,
}: UserNumberPrivacyProps) => {
  const { watch } = useFormContext();

  const numberPrivacyMobile = watch('numberPrivacyMobile');
  const numberPrivacyCorporate = watch('numberPrivacyCorporate');

  if (!numberPrivacyMobile && !numberPrivacyCorporate) {
    return null;
  }

  return (
    <CL.Grid className={dsClass.PADDING_TOP_2}>
      <CL.GridRow className="of-billingAccount-userinfo-form__directory-details">
        <GridColumn className={`${dsClass.PADDING_LEFT_0} ${dsClass.PADDING_TOP_1}`}>
          <NumberPrivacyFields
            numberPrivacy={numberPrivacyMobile}
            directoryDetails={voiceDirectoryDetails}
            type={NumberPrivacyType.PRIVATE}
            disabled={disabled}
          />
        </GridColumn>
        <GridColumn className={`${dsClass.PADDING_LEFT_0} ${dsClass.PADDING_TOP_1}`}>
          {pbxType && (
            <NumberPrivacyFields
              numberPrivacy={numberPrivacyCorporate}
              directoryDetails={corporateDirectoryDetails}
              type={NumberPrivacyType.CORPORATE}
              disabled={disabled}
            />
          )}
        </GridColumn>
      </CL.GridRow>
    </CL.Grid>
  );
};
